package ru.it_mozaika.sender.js.application.components.subscribers

import com.github.doyaaaaaken.kotlincsv.dsl.csvReader
import emotion.styled.styled
import io.ktor.client.call.*
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.async
import kotlinx.coroutines.launch
import mui.icons.material.Cancel

import mui.material.*
import mui.system.responsive
import mui.system.sx
import oldcomponents.NotyType
import oldcomponents.showNotification
import org.khronos.webgl.ArrayBuffer
import org.w3c.files.get

import react.*
import react.dom.html.ReactHTML.input

import ru.it_mozaika.components.commonButtonComponent
import ru.it_mozaika.sender.common.EMAIL_REGEX
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.common.models.SubscriptionList
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.SubscriptionListSelect
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.context.StoreContext
import ru.it_mozaika.sender.js.application.context.SubscriptionListContext
import ru.it_mozaika.sender.js.application.excelUploadRequest
import ru.it_mozaika.styles.hiddenInput
import ru.it_mozaika.styles.styledDialog
import web.cssom.*
import web.file.File
import web.file.FileReader
import web.html.HTMLInputElement
import web.html.InputType

external interface AddNewContactDialogProps: Props{
//    var subscriptionsList: List<SubscriptionList>
    var isOpen: Boolean
    var onClose: () -> Unit

}

val addNewContactDialog = FC<AddNewContactDialogProps> { props ->
    val subscriptionContext = useContext(SubscriptionListContext)
//    val (subscriptions, setSubscriptions) = useState<List<SubscriptionList>>(listOf())
//    val (selectedSubscriptions, setSelectedSubscriptions) = useState<List<SubscriptionList>>(listOf())
    val (uploadFile, setUploadFile) = useState<File>()
    val storeContext = useContext(StoreContext)

    val (selectedStore, setSelectedStore) = useState<Store>()
    val storeList = storeContext.storeList
    val requestResultContext = useContext(RequestResultContext)
    val backDrop = useContext(BackdropContext)
    val uploadButtonRef = useRef<HTMLInputElement>()
    val (fileReadResult, setFileReadResult) = useState<List<Map<String, String>>>(listOf())
    val (openFileProcessing, setOpenFileProcessing) = useState(false)

    val fileProcessing = {
        if (uploadFile != null) {
            when (uploadFile.type) {
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" -> {
                    val reader = FileReader()
                    reader.readAsArrayBuffer(uploadFile)
                    reader.onload = {
                        val buffer = reader.result as ArrayBuffer
                        backDrop.show()
                        excelUploadRequest(
                            path = "/subscribers/add/excel",
                            file = uploadFile,
                            buffer = buffer,
                            query = mapOf(),
                            response = { response ->
                                CoroutineScope(Dispatchers.Default).launch {
                                    val result = async {
                                        response.body<List<Map<String, String>>>()
                                    }.await()
                                    setFileReadResult(result)
                                    setOpenFileProcessing(true)
                                    props.onClose()
                                    backDrop.hide()
                                }
                            }
                        )
                    }
                }

                else -> {
                    CoroutineScope(Dispatchers.Default).launch {
                        backDrop.show()
                        val reader = FileReader()
                        reader.readAsText(uploadFile)
                        reader.onload = {
                            val string = reader.result as String
                            val result = csvReader().readAllWithHeader(string)
                            setFileReadResult(result)
                            setOpenFileProcessing(true)
                            props.onClose()
                            backDrop.hide()

                        }
                    }
                }
            }
        }
    }


    useEffect(storeContext.currentStore) {
        setSelectedStore(storeContext.currentStore)
    }

    if (fileReadResult.isNotEmpty() && selectedStore != null) {
        fileProcessingDialog {
            this.data = fileReadResult
            this.isOpen = openFileProcessing
            this.onClose = { setOpenFileProcessing(false) }
            this.store = selectedStore
            this.subscriptions = subscriptionContext.currentIds.toList()
        }
    }

    Dialog {
        this.open = props.isOpen
        sx {
            width = 100.pct
        }
        DialogTitle {
            +"Создание новых контактов"
        }
        DialogContent {
            Stack {
                sx {
                    padding = 5.px
                }
                direction = responsive(StackDirection.column)
                this.spacing = responsive(2)
                FormControl {

                    sx { minWidth = 200.px }
                    fullWidth = true
                    InputLabel {
                        color = FormLabelColor.secondary
                        id = "new-subscribers-store-select-label"
                        +"Мазагины"
                    }
                    Select {
                        color = InputBaseColor.secondary
                        labelId = "new-subscribers-store-select-label"
                        id = "new-subscribers-store-select"
                        value = selectedStore?.id ?: ""
                        label = ReactNode("Магазины:")
                        onChange = onChange@{ e, _ ->
                            val storeId = e.target.value
                            val newStore = storeList.find { it.id == storeId }
                            setSelectedStore(newStore)
                        }
                        storeList.forEach { store ->
                            MenuItem {
                                value = store.id
                                +store.name
                            }
                        }
                    }
                }
                FormControl {
                    color = FormControlColor.secondary
                    input {
                        hidden = true
                        this.accept =
                            ".csv, .txt, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        this.ref = uploadButtonRef
                        type = InputType.file
                        this.onChange = { event ->
                            val file = event.target.files?.get(0)
                            setUploadFile(file)
                        }
                    }
                    TextField {
                        color = TextFieldColor.secondary
                        value = uploadFile?.name ?: ""

                        id = "file-uploads"
                        label = ReactNode("Выберите файл для загрузки")
                        required = true
                        fullWidth = true
                        variant = FormControlVariant.outlined
                        onMouseDown = {
                            it.preventDefault()
                            it.stopPropagation()
                            uploadButtonRef.current?.click()
                        }

                    }
                }
            }
            DialogActions {
                sx { alignItems = AlignItems.end }
                Stack {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)
                    Button {
                        variant = ButtonVariant.outlined
                        disabled = selectedStore == null || uploadFile == null
                        color = ButtonColor.secondary
                        +"Загрузить"
                        onClick = {
                            subscriptionContext.clearCurrentIds()
                            fileProcessing()
                            props.onClose()
                        }
                    }
                    Button {
                        variant = ButtonVariant.outlined
                        +"Отмена"
                        color = ButtonColor.error
                        onClick = {
                            props.onClose()
                        }
                    }
                }
            }
        }
    }
}